module.exports = __webpack_public_path__ + "img/truck-document.83f588dc.svg";